var _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 209,
    viewBox: "0 0 370 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 9,
    r: 200,
    fill: "url(#paint0_linear_16_160)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 9,
    r: 170,
    transform: "rotate(-180 200 9)",
    fill: "url(#paint1_linear_16_160)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 9,
    r: 110,
    transform: "rotate(-180 200 9)",
    fill: "url(#paint2_linear_16_160)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_160",
    x1: 0,
    y1: 9,
    x2: 400,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#39D1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_160",
    x1: 30,
    y1: 9,
    x2: 370,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#39D1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_160",
    x1: 310,
    y1: 9,
    x2: 90,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#39D1F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat2);
export default __webpack_public_path__ + "static/media/feat-2.7696c6a543b3e371d57283d4ca1d7932.svg";
export { ForwardRef as ReactComponent };